"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCostsRequestStruct = void 0;
const superstruct_1 = require("superstruct");
/**
 * Subset of requests for messaging
 */
exports.MessageCostsRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    from: (0, superstruct_1.string)(),
    until: (0, superstruct_1.string)(), // ISO
});
//# sourceMappingURL=MessageCostsRequest.js.map